import { useMemo } from "react";
import { Form, Select } from "antd";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./styled";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import {
  getOptionsFormAppPart,
  getRuleValidation,
  isCategoryField,
  isCategoryOrStatusField,
} from "@lhd/components/CloneApp/fieldUtils";
import { useBusinessTripReportsChoose } from "./hooks/useBusinessTripReportsChoose";
import { isBlankOrNullStatus } from "@lhd/utility";
import { APP_TYPES } from "../../constants";
import { STATUS_BANNED } from "../../untils";
import { useMatch } from "react-router-dom";
import { ROUTES } from "@lhd/constants";

interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  namePath: string | string[];
  styleColor?: React.CSSProperties;
  onChange?: (state: any) => void;
  appType?: string;
  isCreate?: boolean;
}

const CommonChoose = (props: IProps) => {
  const { item, style, namePath, isDisabled, onChange, appType, isCreate } =
    props;

  const { appPartType } = getConfigAppPartType(item);

  const matchBusinessManuals = useMatch(`/${ROUTES.BUSINESS_MANUALS}/*`);
  const isBusinessManuals =
    appType === APP_TYPES.BUSINESS_MANUALS ||
    (!appType && Boolean(matchBusinessManuals));

  const isBusinessManualsCategory =
    isBusinessManuals &&
    item?.parent_id == null &&
    (item?.field_code === "カテゴリ" ||
      item?.field_code === "category" ||
      item?.name === "カテゴリ" ||
      item?.name === "カテゴリー");

  const isBusinessManualsStatus =
    isBusinessManuals &&
    item?.parent_id == null &&
    (item?.field_code === "status_slicer" ||
      item?.field_code === "status_filter" ||
      item?.name === "ステータス");

  const isBusinessManualsCatalogField =
    isBusinessManualsCategory || isBusinessManualsStatus;

  const isCompanyPoliciesCategory =
    appType === APP_TYPES.COMPANY_POLICIES &&
    item?.parent_id == null &&
    (item?.field_code === "カテゴリー" ||
      item?.name === "カテゴリー" ||
      isCategoryField(item));

  let mode: "multiple" | "tags" | undefined;
  if (
    appPartType === APP_PART_TYPES.MULTI_CHOICE ||
    isBusinessManualsCategory ||
    isCompanyPoliciesCategory
  ) {
    mode = "multiple";
  }

  const {
    isDisableFieldOfBusinessTripReports,
    isCategoryFieldOfBusinessTripReports,
    statusOptions,
    dynamicCategoryOptions,
    isCategoryLoading,
  } = useBusinessTripReportsChoose({ appType, item });

  const options = useMemo(() => {
    let opts = isDisableFieldOfBusinessTripReports
      ? statusOptions
      : isCategoryFieldOfBusinessTripReports
      ? dynamicCategoryOptions
      : (appType === APP_TYPES.COMPANY_POLICIES &&
          [STATUS_BANNED.statusName, STATUS_BANNED.categoryName].includes(
            item?.name || "",
          )) ||
        isBusinessManualsCatalogField
      ? getOptionsFormAppPart(item, appType || "")
      : getOptionsFormAppPart(item, appType || "").map((o) => ({
          value: o.label,
          label: o.label,
        }));

    if (isCategoryOrStatusField(item)) {
      opts = opts.filter((o) => !isBlankOrNullStatus(o));
    }
    return opts;
  }, [
    isDisableFieldOfBusinessTripReports,
    statusOptions,
    isCategoryFieldOfBusinessTripReports,
    dynamicCategoryOptions,
    item,
    appType,
    isBusinessManualsCatalogField,
  ]);

  const initialValue = useMemo(() => {
    if (!isCreate) return undefined;
    if (isCompanyPoliciesCategory) {
      if (Array.isArray(item?.default_value)) {
        return item.default_value
          .map((v) => Number(v))
          .filter((v) => Number.isInteger(v));
      }
      if (
        item?.default_value !== undefined &&
        item?.default_value !== null &&
        item?.default_value !== ""
      ) {
        const num = Number(item.default_value);
        return Number.isInteger(num) ? [num] : [];
      }
      return [];
    }
    if (isBusinessManualsCategory) {
      if (Array.isArray(item?.default_value)) {
        return item.default_value
          .map((v) => Number(v))
          .filter((v) => Number.isInteger(v));
      }
      if (
        item?.default_value !== undefined &&
        item?.default_value !== null &&
        item?.default_value !== ""
      ) {
        const num = Number(item.default_value);
        return Number.isInteger(num) ? [num] : [];
      }
      return [];
    }
    if (isBusinessManualsStatus) {
      if (
        item?.default_value !== undefined &&
        item?.default_value !== null &&
        item?.default_value !== ""
      ) {
        const num = Number(item.default_value);
        return Number.isInteger(num) ? num : undefined;
      }
      return undefined;
    }
    return undefined;
  }, [
    isCreate,
    isCompanyPoliciesCategory,
    isBusinessManualsCategory,
    isBusinessManualsStatus,
    item?.default_value,
  ]);

  const form = Form.useFormInstance();
  const color = form.getFieldValue(namePath + ".text_color");
  const background = form.getFieldValue(namePath + ".background_color");

  return (
    <Styles style={style} id={item.id} color={color} background={background}>
      <Form.Item
        name={namePath}
        rules={getRuleValidation(item)}
        initialValue={initialValue}
      >
        <Select
          mode={mode}
          allowClear
          disabled={isDisabled || isDisableFieldOfBusinessTripReports}
          loading={isCategoryFieldOfBusinessTripReports && isCategoryLoading}
          onChange={(state) => {
            onChange && onChange(state);
          }}
        >
          {options.map((option, i) => {
            return (
              <Select.Option
                key={i}
                value={option.value}
                className="custom-option"
              >
                {option.label}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </Styles>
  );
};
export default CommonChoose;
